import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import AboutUs from "../FastSearch/components/AboutUs";
import "./style.css";
import "../../../../index.css";
class FastSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      css: {},
      showAboutus: false,
    };
  }

  componentDidMount() {
    this.fixCss();
  }
  render() {
    return (
      <div className="fastSearch_box">
        <img
          onClick={() => this.handleShowOrClose()}
          className="fl"
          alt=""
          src={require("../../../../images/fastSearch/about.png")}
        ></img>
        <NavLink to="/articlelist?categoryId=2&search=false">
          <img
            className="fr"
            alt=""
            src={
              this.state.css.width > 750
                ? require("../../../../images/fastSearch/fast_search_new.png")
                : require("../../../../images/fastSearch/fast_search.png")
            }
          ></img>
        </NavLink>
        {this.state.showAboutus === true ? (
          <AboutUs handleShowOrClose={this.handleShowOrClose}></AboutUs>
        ) : null}
      </div>
    );
  }
  handleShowOrClose = () => {
    this.setState({
      showAboutus: !this.state.showAboutus,
    });
  };
  fixCss = () => {
    let width = window.innerWidth;
    this.setState({
      css: {
        width: width,
      },
    });
  };
}

export default FastSearch;



// WEBPACK FOOTER //
// ./src/containers/Home/components/FastSearch/index.js